import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import Nav from '../../components/marketing/Nav';
import Footer from '../../components/marketing/Footer';
import { Button } from '../../components/ui/button';
import { PLANS } from '../../lib/constants';

export default function Pricing() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#090A0F]">
      <Nav />
      <section className="max-w-7xl mx-auto px-5 pt-16 pb-8 text-center relative grain">
        <div className="absolute inset-0 brand-glow pointer-events-none" />
        <div className="relative">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00] mb-4">Pricing</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Pay for minutes, not promises.</h1>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto">
            AI video processing has real infrastructure costs. Every plan gives you a clear monthly pool of processing minutes.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 pb-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PLANS.map((p) => (
          <div key={p.key} data-testid={`pricing-${p.key}`}
            className={`rounded-2xl border p-7 flex flex-col ${p.popular ? 'border-[#FF4D00]/50 bg-[#161926] shadow-xl shadow-[#FF4D00]/5' : 'border-white/10 bg-[#12141D]'}`}>
            {p.popular && <div className="font-mono text-[10px] uppercase tracking-widest text-[#FF4D00] mb-2">Most popular</div>}
            <div className="font-heading font-semibold text-xl">{p.name}</div>
            <div className="text-sm text-slate-400 mt-1">{p.tagline}</div>
            <div className="mt-5"><span className="font-heading text-4xl font-extrabold">${p.price}</span><span className="text-slate-500 text-sm">/month</span></div>
            <ul className="space-y-2.5 mt-6 flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm text-slate-300">
                  <Check className="w-4 h-4 text-[#FF884D] mt-0.5 shrink-0" />{f}
                </li>
              ))}
            </ul>
            <Button onClick={() => nav('/signup')} variant={p.popular ? 'default' : 'outline'}
              className={`w-full mt-7 rounded-full ${p.popular ? '' : 'border-white/15 bg-white/5 hover:bg-white/10'}`}>
              {p.price === 0 ? 'Start free' : 'Get started'}
            </Button>
          </div>
        ))}
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-24">
        <div className="rounded-2xl border border-white/10 bg-[#12141D] p-8 text-center">
          <div className="font-heading text-2xl font-bold">Enterprise</div>
          <p className="text-slate-400 mt-2">Custom minutes, dedicated rendering, SSO and volume pricing for agencies & networks.</p>
          <Button onClick={() => nav('/help')} variant="outline" className="rounded-full mt-5 border-white/15 bg-white/5 hover:bg-white/10">Contact sales</Button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
